export default __webpack_public_path__ + "static/diamond_w.952f2c5dc98850070413c087210307bc.svg";